// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iK","advertCardNum":"c-a_iL"};